//creating job details model

exelare_jobs.define('jobListModel',['noconflict', 'knockout', 'datasource', 'helpers'], function ($, ko, AjaxDataSource, helpers) {
        return function (creds) {

        var self = this;
        
        var customSearchControls = $('#searchForm [search-fieldname]');

        for (var i = 0; i < customSearchControls.length; i++) {
        	var formControl = customSearchControls[i];
            var fieldName = $(formControl).attr("search-fieldname");

            if ($(formControl).attr('multiple')) {
                self[fieldName] = ko.observableArray([]);
            } else {
                self[fieldName] = ko.observable("");
            }

        	
        	if ($(formControl).attr('search-lookup')) {
        		var lookupFieldName = fieldName + "Lookup";
        		self[lookupFieldName] = ko.observableArray([]);
				//setTimeout because first request is always jobs, to cache the access token. Then lookups load with this access token
        		setTimeout(helpers.getService, 1000, 'lookup', {
        				companyId: creds.companyId,
        				userId: creds.userId,
        				pwd: creds.pwd ? creds.pwd : '',
        				lookupPath: $(formControl).attr('search-lookup'),
        				lookupName: lookupFieldName
        			}, function (resp) {
        				self[resp.LookupName](resp.Records);
        			});
        	}
        }

        self.getCustomFilterValues = function () {
        	var cols = [];
        	for (var i = 0; i < customSearchControls.length; i++) {
        		var formControl = customSearchControls[i];
        		var fieldName = $(formControl).attr("search-fieldname");
        		var col = { name: fieldName, value: self[fieldName](), multiple: false, selectMultiple: false };
				
		        if ($(formControl).attr('search-multiple')) {
        			col.multiple = true;
                }

                if ($(formControl).attr('multiple')) {
                    col.selectMultiple = true;
                }

                if ($(formControl).attr('search-filter-type')) {
                    col.filterType = $(formControl).attr('search-filter-type') ;
                }

        		cols.push(col);
        	}

        	console.log(cols);

        	for (var i = 0; i < cols.length; i++) {
		        var col = cols[i];
		        if (col.name == 'ZipCode' && col.value) {
		        	cols.push({ name: "Fake__ZipDistance", value: col.value, value2: helpers.find(cols, function (c) { return c.name == "ZipDistance" }).value, isFakeField: true, dataType: 'Integer'});
		        }
        	}

        	helpers.remove(cols, "ZipCode");
        	helpers.remove(cols, "ZipDistance");

        	return cols;
        }
			
        var dataSource = new AjaxDataSource({
            companyId: creds.companyId,
            userId: creds.userId,
        	pwd: creds.pwd?creds.pwd:''
        });
        var options = {
            pageIndex: 0,
            pageSize: ExelareSettings.pageSize
        }

        if (creds.jobId) options.jobId = creds.jobId;
	    
        var getJobType=function(jtype) {
            switch(jtype) {
                case "Contract": return "CONTRACTOR";
                case "Full Time/Direct Hire": "FULL_TIME";
            }
            return "FULL_TIME";
        }

        var writeStructData=function(rec, compDetails) {
            var script = document.createElement('script');
            var jobObj= {
                "@context" : "http://schema.org/",
                "@type" : "JobPosting",
                "title" : rec["JobTitle"](),
                "description" : rec["htmlDescription"](),
                "identifier": {
                    "@type": "PropertyValue",
                    "name": "ReqID",
                    "value": rec["ReqID"]()
                },
                "datePosted": rec["PostDateISO"](),
                "employmentType" : getJobType(rec["JobType"]()),
                "hiringOrganization" : {
                    "@type" : "Organization",
                    "name": compDetails.CompanyName
                },
                "skills": rec.primarySkills(),
                "industry": rec.industry(),
                "educationRequirements": rec.education(),
                "experienceRequirements": rec.totalExp(),
                "jobLocation" : {
                    "@type" : "Place",
                    "address" : {
                        "@type" : "PostalAddress",
                        "streetAddress" : rec.address(),
                        "addressLocality" : rec.city(),
                        "addressRegion" : rec.state(),
                        "postalCode" : rec.zipCode(),
                        "addressCountry": "US"
                    }
                },
                "validThrough": rec["EndDate"]()
            }
            if (rec.minSalary()) {
                jobObj["baseSalary"] = {
                    "@type": "MonetaryAmount",
                    "currency": "USD",
                    "value": {
                        "@type": "QuantitativeValue",
                        "value": rec.minSalary(),
                        "unitText": "YEAR"
                    }
                }
            }
                                
            script.type = 'application/ld+json';
            script.text = JSON.stringify(jobObj);
            document.querySelector('head').appendChild(script);

            var script2 = document.createElement('script');
            script2.type = 'application/ld+json';
            script2.text = JSON.stringify({
                "@context": "http://schema.org",
                "@type": "Organization",
                "url": compDetails.CompanyUrl,
                "logo": compDetails.LogoUrl
            });
            document.querySelector('head').appendChild(script2);
        }


        var load = function (opts) {
        	helpers.displayLoader(true);
        
            dataSource.data(opts, function (resp) {
                var recs = [];
                for (var i = 0; i < resp.data.length; i++) {
                    recs.push(new JobDetailModel(resp.data[i], resp.schema, appForm));
                }

                var _pList=[];
                for (var i = 1; i <= resp.pages; i++) {
                    _pList.push(i);
                }
                self.pagesList(_pList);

                self.pageNumber(resp.page);
                self.totalPages(resp.pages);
                self.records(recs);
                
                
                helpers.getService("companies", { cid: creds.companyId }, function (resp) {
                    if (opts.jobId) {
                        writeStructData(recs[0], resp);
                        $("head > title").html(recs[0]["JobTitle"]() + " - " + resp.CompanyName);
                        var descMeta = $("<meta>", {
                            name: "description",
                            content: recs[0].nohtmlDescription()
                        });
                        $("head").append(descMeta);
                    } else {
                        $("head > title").html("Open Jobs" + " - " + resp.CompanyName);
                    }
                }, "GET");
                    
                helpers.displayLoader(false);
            });
        }

        self.pageNumber = ko.observable(0);
        self.goToPage = function(val) {
            if (val) {
                options.pageIndex = parseInt(val)-1;
                load(options);
            }
        }

    
        self.pagesList = ko.observableArray([]);
        self.totalPages = ko.observable(0);
        self.searchKeywords = ko.observable("");
        self.searchLocation = ko.observable("");
        self.records = ko.observableArray([]);

        //initialise
        load(options);


        self.search = function () {
            //location.hash = "";
            //if (location.search) {
            //    location.search = "companyId=" + creds.companyId + "&userId=" + creds.userId;
            //} else {
                location.hash = "companyId=" + creds.companyId + "&userId=" + creds.userId;
            //}

            options = {
                pageIndex: 0,
                pageSize: ExelareSettings.pageSize
            }

            options.search = self.searchKeywords();
            options.location = self.searchLocation();
            var cols = self.getCustomFilterValues();
            if (cols.length > 0) {
            	options.customSearch = { columns: cols };
            }

            load(options);
        }

        self.clear = function () {
            //if (location.search) {
            //    location.search = "companyId=" + creds.companyId + "&userId=" + creds.userId;
            //} else {
                location.hash = "companyId=" + creds.companyId + "&userId=" + creds.userId;
            //}
            
            self.searchKeywords("");
            self.searchLocation("");

            for (var i = 0; i < customSearchControls.length; i++) {
            	var formControl = customSearchControls[i];
            	var fieldName = $(formControl).attr("search-fieldname");
            	self[fieldName]("");
            }

            options = {
                pageIndex: 0,
                pageSize: ExelareSettings.pageSize
            }

            load(options);
        }

        self.prevPage = function () {
            if (self.hasPrevPage()) {
                options.pageIndex--;
                load(options);
            };
        }

        self.nextPage = function () {
            if (self.hasNextPage()) {
                options.pageIndex++;
                load(options);
            };
        }

        self.hasNextPage = ko.computed(function () {
            return (parseInt(self.pageNumber()) + 1) <= self.totalPages();
        });

        self.hasPrevPage = ko.computed(function () {
            return (parseInt(self.pageNumber())-1) > 0;
        });
    };
})
;
